import { apiFetch } from './apiFetch';
import { v4 as uuidv4 } from 'uuid';

export async function paymentCall(phoneNumber, receiverName, msgId) {
  try {
    const response = await apiFetch('/payment/pay', {
      method: 'POST',
      redirect: 'manual',
      body: JSON.stringify({
        msg_req: {
          cid: uuidv4(),
          phone_number: phoneNumber,
          receiver_name: receiverName,
          msg_id: msgId,
        },
      }),
    });
    const data = await response.json().catch(() => ({}));
    return data.redirect_url;
  } catch (error) {
    console.error('Error paying payment: ', error);
    throw error;
  }
}
